import { call } from '../actions/utils';

//**** STATION CRUD
export const createReport = async (data, accessToken) =>
  await call({
    url: '/api/reports/create',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const updateReport = async (data, accessToken) =>
  await call({
    url: '/api/reports/update',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const removeReport = async (data, accessToken) =>
  await call({
    url: '/api/reports/remove',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const endReport = async (data, accessToken) =>
  await call({
    url: '/api/reports/end',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findAllReports = async (data, accessToken) =>
  await call({
    url: '/api/reports/find/all',
    data: { data },
    token: accessToken
  });
export const findReportById = async (data, accessToken) =>
  await call({
    url: '/api/reports/find/by/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findReportByName = async (data, accessToken) =>
  await call({
    url: '/api/reports/by/name',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findReportsByStationId = async (data, accessToken) =>
  await call({
    url: '/api/reports/find/all/by/station/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
